import angular from 'angular';
import faceHeaderComponent from './face-header.component';

import sideNavMaskControl from './side-nav-mask-control.directive';
import sideNavControl from './side-nav-control.directive';

let faceHeaderModule = angular.module('faceHeader', [])

    .component('faceHeader', faceHeaderComponent)
    .directive('sideNavMaskControl', sideNavMaskControl)
    .directive('sideNavControl', sideNavControl)

.name;

let states = [];

export default {name: faceHeaderModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/face/face-header/face-header.js